import { Reducer } from 'redux';
import { persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage';

import { LOAD_ACCESS_LOG, SUCCESS_ACCESS_LOG } from 'action-creators/accessLog';
import { RESET } from 'action-creators/generic';

export interface AccessLogState {
  ListUsersAndInvites: boolean;
  CreateUser: boolean;
  CreateGroup: boolean;
  ListGroups: boolean;
  CreateCostCenter: boolean;
  ListCostCenter: boolean;
  RulesListTour: boolean;
  RulesCreateTour: boolean;
  isLoading: boolean;
  ExpensesReport: boolean;
  ListBranchCompany: boolean;
}

const initialState: AccessLogState = {
  isLoading: false,
  ListUsersAndInvites: false,
  CreateUser: false,
  CreateGroup: false,
  ListGroups: false,
  CreateCostCenter: false,
  ListCostCenter: false,
  RulesListTour: false,
  RulesCreateTour: false,
  ExpensesReport: false,
  ListBranchCompany: false,
};

const reducer: Reducer<AccessLogState> = (state = initialState, action) => {
  switch (action.type) {
    case LOAD_ACCESS_LOG:
      return {
        ...state,
        isLoading: true,
      };
    case SUCCESS_ACCESS_LOG: {
      return {
        ...state,
        [action.data.screenName]: action.data.hasAccess,
        isLoading: false,
      };
    }

    case RESET:
      return initialState;
    default:
      return state;
  }
};

const persistConfig = {
  storage,
  version: 1,
  key: 'accessLog',
};

export default persistReducer(persistConfig, reducer);
